import { Button } from 'antd';
import { Animation, Icon } from '@common/components';
import React from 'react';

type ToggleButtonProps = {
  expanded: boolean;
  onClick: () => void;
};

export const ToggleButton = ({ expanded, onClick }: ToggleButtonProps) => (
  <span className="toggle-button">
    <Button
      type="link"
      className="billing-rate-rate-card-item-toggle-button"
      onClick={onClick}
    >
      <Animation kind="rotate-left" active={expanded}>
        <Icon icon="chevronDown" />
      </Animation>
    </Button>
    <style jsx>{`
      .toggle-button :global(.ant-btn) {
        padding: 0 8px 0 0;
        height: 16px;
      }
      .toggle-button :global(.wk-animation) {
        line-height: 0;
        vertical-align: top;
      }
    `}</style>
  </span>
);
